import Bugsnag from '@bugsnag/js'

export const clearLogMetadata = Bugsnag.clearMetadata
